import { client } from 'app/http';

export const updateASOnePlan = async (id: string, body: unknown) => {
  const { data } = await client.post(`/admin/as-one-plan/${id}`, body);
  return data;
};
